module.exports = __webpack_public_path__ + "static/excellence-dbd4880716b4b70de1ba4a30d68da7c0.png";